module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Video"
  }, [_c('video', {
    directives: [{
      name: "lazyload",
      rawName: "v-lazyload",
      value: ({
        callback: _vm.onLoaded
      }),
      expression: "{ callback: onLoaded }"
    }],
    staticClass: "Video-video",
    attrs: {
      "muted": "",
      "loop": "",
      "playsinline": "",
      "autoplay": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "data-src": _vm.src,
      "type": "video/mp4"
    }
  })]), _vm._v(" "), (!_vm.isLoaded) ? _c('base-image', {
    staticClass: "Video-placeholder u-posFit",
    attrs: {
      "size": "cover",
      "src": _vm.placeholderSrc
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b35c384","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseVideo.vue
// module id = 178
// module chunks = 1